import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SecurityService } from "../../service/security.service";
import { UserService } from "src/app/property-management-dashboard/service/user.service";

@Component({
  selector: "app-callback",
  templateUrl: "./callback.component.html",
  styleUrls: ["./callback.component.scss"],
})
export class CallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private securityService: SecurityService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((queryParam) => {
      if (queryParam["token"]) {
        this.securityService.updateToken(queryParam["token"]);
        this.userService.getUserInfo().subscribe((res: any) => {
          let map = res["serviceMap"];
          if (map && Object.keys(map).length === 0) {
            map = { "": "" };
            this.securityService.updateUserInfo(map);
            this.router.navigate(["/property-dashboard/request-access"]);
            return;
          }
          this.securityService.updateUserInfo(map);
          const key = Object.keys(map)[0];
          if(map[key] == "ROLE_USER"){
            this.userService.getMyBuids(key).subscribe((res: string[]) => {
              if (res[0] == "*") {
                this.securityService.setAllBuids(true);
              }
            })
          }
          this.router.navigate(["/property-dashboard/default-properties"]);
        });
      }
      if(queryParam["picture"]) {
        this.securityService.setProfileImage(queryParam["picture"]);
      }
    });
  }
}
